import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send, CheckCircle2, MessageCircle } from 'lucide-react';
import './Contact.css';

const SUBS = [
  'Food Products Enquiry',
  'Spices & Masala Enquiry',
  'Textile Products Enquiry',
  'Resin Art / Handicraft Enquiry',
  'Bulk Order Enquiry',
  'Export Enquiry',
  'General Enquiry',
];

const OFFICES = [
  { city:'Pune HQ',    ph:'+91 77758 92822', em:'yashrajtradersindia11@gmail.com', hrs:'Mon–Sat 9AM–7PM IST',  f:'🏢' },
  { city:'WhatsApp',   ph:'+91 92263 18469', em:'Chat available on WhatsApp',      hrs:'Quick response',       f:'💬' },
  { city:'Alt Phone',  ph:'+91 80878 84319', em:'yashrajtradersindia11@gmail.com', hrs:'Mon–Sat 9AM–6PM IST',  f:'📞' },
];

export default function Contact() {
  const [form, setForm] = useState({ name:'', company:'', email:'', phone:'', subject:'', message:'' });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    /* ── Send via mailto (opens email client) ── */
    const subjectLine = encodeURIComponent(
      `[Yashraj Traders Enquiry] ${form.subject} — from ${form.name}`
    );
    const bodyText = encodeURIComponent(
      `Hello Yashraj Traders India,\n\n` +
      `NAME: ${form.name}\n` +
      `COMPANY: ${form.company || 'N/A'}\n` +
      `EMAIL: ${form.email}\n` +
      `PHONE: ${form.phone || 'N/A'}\n` +
      `SUBJECT: ${form.subject}\n\n` +
      `MESSAGE:\n${form.message}\n\n` +
      `---\nSent from Yashraj Traders website`
    );

    /* Open the user's default email app pre-filled */
    const mailtoLink = `mailto:yashrajtradersindia11@gmail.com?subject=${subjectLine}&body=${bodyText}`;
    window.location.href = mailtoLink;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
    }, 1000);
  };

  return (
    <div className="page-enter" style={{ paddingTop: 80 }}>
      <section className="page-hero">
        <div className="page-hero__stripe"/><div className="page-hero__dots"/>
        <div className="container page-hero__inner">
          <div className="tag" style={{ marginBottom: 16 }}>Let's Talk</div>
          <h1 className="page-hero__title">Contact <em>Yashraj Traders</em></h1>
          <p className="page-hero__desc">
            For product enquiries, bulk orders or any questions — call, WhatsApp or fill the form below. We respond quickly.
          </p>
        </div>
      </section>

      <section className="ct-sec">
        <div className="container ct-layout">

          {/* ── FORM ── */}
          <div className="ct-form-wrap">
            {done ? (
              <div className="ct-success">
                <CheckCircle2 size={56} color="var(--fire)"/>
                <h3>Enquiry Sent!</h3>
                <p>
                  Your email app has opened with the enquiry details pre-filled.<br/>
                  Please click <strong>Send</strong> in your email app to complete the submission.
                </p>
                <p style={{fontSize:13,marginTop:10,color:'var(--text-soft)'}}>
                  Or email us directly at:<br/>
                  <strong style={{color:'var(--fire)'}}>yashrajtradersindia11@gmail.com</strong>
                </p>
                <div className="ct-success__actions">
                  <a href="https://wa.me/919226318469" className="btn btn-ink" target="_blank" rel="noreferrer">
                    <MessageCircle size={15}/> Also WhatsApp Us
                  </a>
                  <button className="btn btn-outline" onClick={()=>{ setDone(false); setForm({name:'',company:'',email:'',phone:'',subject:'',message:''}); }}>
                    Send Another Enquiry
                  </button>
                </div>
              </div>
            ) : (
              <form onSubmit={submit}>
                <h2 className="ct-title">Send an Enquiry</h2>
                <p className="ct-sub">
                  Fill in your details and click Send — your email app will open with the message ready to send to us.
                </p>

                {error && <div className="ct-error">{error}</div>}

                <div className="ct-row">
                  <div className="ct-g"><label>Full Name *</label><input name="name" value={form.name} onChange={set} required placeholder="Your full name"/></div>
                  <div className="ct-g"><label>Company / Business</label><input name="company" value={form.company} onChange={set} placeholder="Optional"/></div>
                </div>
                <div className="ct-row">
                  <div className="ct-g"><label>Email Address *</label><input type="email" name="email" value={form.email} onChange={set} required placeholder="your@email.com"/></div>
                  <div className="ct-g"><label>Phone Number</label><input name="phone" value={form.phone} onChange={set} placeholder="+91 XXXXX XXXXX"/></div>
                </div>
                <div className="ct-g ct-g--full">
                  <label>Enquiry Type *</label>
                  <select name="subject" value={form.subject} onChange={set} required>
                    <option value="">Select enquiry type...</option>
                    {SUBS.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="ct-g ct-g--full">
                  <label>Your Message *</label>
                  <textarea name="message" value={form.message} onChange={set} required rows={5}
                    placeholder="Tell us about your requirement — products needed, quantities, delivery location and any special requirements..."/>
                </div>

                <button type="submit" className="btn btn-fire ct-submit" disabled={loading}>
                  {loading ? 'Opening email app...' : <><Send size={15}/> Send Enquiry to Yashraj Traders</>}
                </button>
                <p className="ct-note">
                  📧 This will open your email app pre-filled and ready to send to yashrajtradersindia11@gmail.com
                </p>
              </form>
            )}
          </div>

          {/* ── SIDEBAR ── */}
          <div className="ct-side">
            {OFFICES.map((o,i) => (
              <div key={i} className="ct-office">
                <div className="ct-o-flag">{o.f}</div>
                <div className="ct-o-city">{o.city}</div>
                <div className="ct-o-row"><Phone size={13}/>{o.ph}</div>
                <div className="ct-o-row"><Mail size={13}/>{o.em}</div>
                <div className="ct-o-row"><Clock size={13}/>{o.hrs}</div>
              </div>
            ))}

            <div className="ct-quick">
              <h4>Quick Actions</h4>
              <a href="tel:+917775892822"      className="ct-qbtn ct-qbtn--fire"><Phone size={15}/> Call +91 77758 92822</a>
              <a href="tel:+918087884319"      className="ct-qbtn ct-qbtn--ink"><Phone size={15}/> Call +91 80878 84319</a>
              <a href="https://wa.me/919226318469" className="ct-qbtn ct-qbtn--wa" target="_blank" rel="noreferrer"><MessageCircle size={15}/> WhatsApp Now</a>
              <a href="mailto:yashrajtradersindia11@gmail.com" className="ct-qbtn ct-qbtn--email"><Mail size={15}/> Send Email</a>
            </div>

            <div className="ct-gstin">
              <div className="ct-gstin__label">GSTIN</div>
              <div className="ct-gstin__num">27CBFPB6539R1Z2</div>
              <div className="ct-gstin__loc">🇮🇳 Pune, Maharashtra, India</div>
            </div>
          </div>
        </div>
      </section>

      {/* Address section */}
      <section style={{ padding:'72px 0', background:'var(--off)' }}>
        <div className="container">
          <div className="tag" style={{ marginBottom:14 }}>Location</div>
          <h2 className="display" style={{ marginBottom:32 }}>Find <em>Yashraj Traders</em></h2>
          <div className="ct-addrs">
            {[
              { lbl:'Headquarters',    addr:'Pune, Maharashtra — 411001, India',                                           note:'Mon–Sat 9AM–7PM IST', hq:true },
              { lbl:'Phone Numbers',   addr:'+91 77758 92822  ·  +91 80878 84319',                                        note:'Call us anytime' },
              { lbl:'WhatsApp',        addr:'+91 92263 18469',                                                             note:'Quick response guaranteed' },
              { lbl:'Email',           addr:'yashrajtradersindia11@gmail.com',                                             note:'Response within 24 hours' },
            ].map((a,i) => (
              <div key={i} className={`ct-addr ${a.hq?'ct-addr--hq':''}`}>
                <MapPin size={16} color={a.hq?'var(--fire)':'var(--gray-4)'} style={{ flexShrink:0, marginTop:2 }}/>
                <div>
                  <div className="ct-addr__l">{a.lbl}</div>
                  <div className="ct-addr__a">{a.addr}</div>
                  {a.note && <div className="ct-addr__n">{a.note}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
